import { BookingData } from "./BookingData";
import { Cell } from "../view/Cell";

enum State
{
	NONE,
	START,
	END
}

export class BookingHandler
{
	private _state: State;
	private _startCell: Cell | null;
	private _endCell: Cell | null;
	private _clickedCell: Cell;

	public get from(): Date | null
	{
		return this._startCell ? this._startCell.date : null;
	}

	public get to(): Date | null
	{
		return this._endCell ? this._endCell.date : null;
	}

	constructor(
		private readonly _bookingData: BookingData
	)
	{
		this._state = State.NONE;
		this._startCell = null;
		this._endCell = null;
	}

	public reset(): void
	{
		this._state = State.NONE;
		this._startCell = null;
		this._endCell = null;
	}

	public onCellClick(cell: Cell): void
	{
		this._clickedCell = cell;

		switch (this._state)
		{
			case State.NONE:
				this.setFirst(cell);
				break;

			case State.START:
				if (cell === this._startCell || cell === this._endCell)
				{
					this._startCell = null;
					this._endCell = null;
					this._state = State.NONE;
				}
				else if (this._startCell)
				{
					this._endCell = cell;
					this.validate();
				}
				else if (this._endCell)
				{
					this._startCell = cell;
					this.validate();
				}
				break;

			case State.END:
				if (cell === this._endCell)
				{
					this._endCell = null;
					this._state = State.START;
				}
				else if (cell === this._startCell)
				{
					this.setFirst(cell);
				}
				else
				{
					this.adjustSelection(cell);
				}
				break;
		}
	}

	private setFirst(cell: Cell): void
	{
		if (this._bookingData.isBookedCheckIn(cell.time))
		{
			this._startCell = null;
			this._endCell = cell;
			this._state = State.START;
		}
		else if (!this._bookingData.isBookedFull(cell.time) || this._bookingData.isBookedCheckOut(cell.time))
		{
			this._endCell = null;
			this._startCell = cell;
			this._state = State.START;
		}
	}

	private validate(): void
	{
		if (this._startCell.time > this._endCell.time)
		{
			const tmp = this._startCell;
			this._startCell = this._endCell;
			this._endCell = tmp;
		}

		const date = new Date(this._startCell.date);
		const endTs = this._endCell.time;
		let time = date.getTime();

		while(time < endTs)
		{
			const prevTime = time;
			date.setDate(date.getDate() + 1);
			time = date.getTime();

			if (this._bookingData.isBookedFull(time)
			|| (this._bookingData.isBookedCheckIn(prevTime) && this._bookingData.isBookedCheckOut(time)))
			{
				this.setFirst(this._endCell);
				return;
			}
		}

		this._state = State.END;
	}

	private adjustSelection(cell: Cell): void
	{
		const timestamp = cell.time;

		if (this._startCell.time > timestamp) // before selection
		{
			this._startCell = cell;
		}
		else if (this._endCell.time < timestamp) // after
		{
			this._endCell = cell;
		}
		else
		{
			this._endCell = cell;
		}

		this.validate();
	}
}
